import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import Header from "@/components/Header";
import { useAuth } from "@/lib/auth";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { toast } from "sonner";
import PasswordInput from "@/components/PasswordInput";
import { maskCPF, maskPhone } from "@/lib/utils-app";
import GoogleLoginButton from "@/components/GoogleLoginButton";

export default function RegisterPage() {
  const { register } = useAuth();
  const nav = useNavigate();
  const [form, setForm] = useState({ name: "", email: "", cpf: "", phone: "", password: "" });
  const [loading, setLoading] = useState(false);

  const set = (k) => (e) => {
    let v = e.target.value;
    if (k === "cpf") v = maskCPF(v);
    if (k === "phone") v = maskPhone(v);
    setForm({ ...form, [k]: v });
  };

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await register({ ...form, cpf: form.cpf.replace(/\D/g, ""), phone: form.phone });
      toast.success("Conta criada!");
      nav("/minha-conta");
    } catch (e) { toast.error(e.response?.data?.detail || "Erro"); }
    finally { setLoading(false); }
  };

  return (
    <div className="min-h-screen bg-neutral-50">
      <Header />
      <div className="max-w-md mx-auto px-4 sm:px-6 py-10 sm:py-16">
        <div className="text-xs uppercase tracking-[0.25em] font-bold text-neutral-500 mb-3">Novo cadastro</div>
        <h1 className="font-heading font-black text-3xl sm:text-4xl tracking-tight">Criar conta</h1>

        <div className="mt-8">
          <GoogleLoginButton testid="register-google" />
          <div className="my-6 flex items-center gap-4 text-xs uppercase tracking-widest text-neutral-400">
            <div className="flex-1 h-px bg-neutral-200" />
            ou preencha
            <div className="flex-1 h-px bg-neutral-200" />
          </div>
        </div>

        <form onSubmit={submit} className="space-y-4" data-testid="register-form">
          <div><Label>Nome completo</Label><Input value={form.name} onChange={set("name")} className="mt-1.5 h-12" data-testid="reg-name" required /></div>
          <div><Label>E-mail</Label><Input type="email" value={form.email} onChange={set("email")} className="mt-1.5 h-12" data-testid="reg-email" required /></div>
          <div className="grid grid-cols-2 gap-3">
            <div><Label>CPF</Label><Input value={form.cpf} onChange={set("cpf")} placeholder="000.000.000-00" className="mt-1.5 h-12 font-mono" data-testid="reg-cpf" /></div>
            <div><Label>WhatsApp</Label><Input value={form.phone} onChange={set("phone")} placeholder="(11) 90000-0000" className="mt-1.5 h-12 font-mono" data-testid="reg-phone" /></div>
          </div>
          <div><Label>Senha</Label><PasswordInput value={form.password} onChange={set("password")} minLength={6} className="mt-1.5 h-12" data-testid="reg-password" required /></div>
          <Button type="submit" disabled={loading} className="w-full h-12 rounded-md bg-neutral-900 hover:bg-neutral-800" data-testid="reg-submit">
            {loading ? "Criando…" : "Criar conta"}
          </Button>
        </form>

        <div className="mt-8 text-sm text-neutral-600">
          Já tem conta? <Link to="/login" className="underline font-semibold text-neutral-900">Entrar</Link>
        </div>
      </div>
    </div>
  );
}
